import { CreateTravelTaskDto } from "@/core/features/tasks/embed-dtos/create-travel-task.dto";

export class UpdateTravelTaskDto extends CreateTravelTaskDto {}
